<div class="space-y-2 text-left" [class.mt-5]="!noMarginTop" [class.w-full]="fullWidthInput">
  @if (label) {
    <label class="text-style-form-label" [class.text-gray-200]="disabled" [class.cursor-not-allowed]="disabled">
      {{ label | translate }}
      @if (isRequired) {
        <span class="text-red-500">*</span>
      }
    </label>
  }
  <div class="relative">
    <div [class]="inputContainerClass">
      @if (icon && iconPosition === 'left') {
        <i [class]="'ph ph-icon ' + icon + ' absolute left-3 text-gray-400'"></i>
      }
      <input
        [type]="type"
        [disabled]="disabled"
        [id]="inputId"
        [name]="placeholder"
        class="form-input-base"
        [placeholder]="placeholder"
        [maxlength]="maxLength"
        [class]="modifiedInputClass"
        [class.border-red-500]="control?.touched && control?.invalid"
        [class.border-gray-300]="!(control?.touched && control?.invalid)"
        [class.bg-gray-100]="disabled"
        [class.text-gray-500]="disabled"
        [class.cursor-not-allowed]="disabled"
        [formControl]="control"
        (blur)="onTouched()"
        (input)="onInput($event)"
      />
      @if (icon && iconPosition === 'right') {
        <i [class]="'ph ph-icon ' + icon + ' absolute right-3 text-gray-400'"></i>
      }
    </div>

    @if (copyFromClipboard && !clipboardDenied) {
      <a
        (click)="copyFromClipboardFunction()"
        class="underline text-blue-600 hover:text-blue-800 cursor-pointer text-sm inline-block text-left"
      >
        {{ 'pasteFromClipboard' | translate }}
      </a>
    }

    @if ((control?.touched && control?.invalid && control?.value) || showError) {
      <div class="text-red-500 text-sm mt-1">
        {{ errorMessage | translate }}
      </div>
    }
  </div>
</div>
